import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Button, ButtonProps } from 'shared/components/Button/Button';
import { mergeClasses } from 'shared/utils/mergeClasses';

interface LinkButtonProps extends ButtonProps {
  to: string;
}

export const LinkButton: FC<LinkButtonProps> = ({ to, variant = 'text', ...buttonProps }) => {
  return (
    <Link to={to}>
      <Button
        {...buttonProps}
        variant={variant}
        className={mergeClasses('!inline-block', buttonProps.className ?? '')}
      />
    </Link>
  );
};
